import React from 'react';
import YouTube from "react-youtube";
import { useAudio } from '../context/audio';
import {usePlayer} from '../context/player';

export default function Player(){

  const {audio, setAudio} = useAudio();

  const {setPlayer} = usePlayer();

    const options = {
      height: '0',
      width: '0',
      host: `https://www.youtube.com`,
      playerVars: {
        origin: `${window.location.href}`,
      }
    }

    function getMinutes(duration) {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    return `${minutes}:${seconds}`;
  }

    return(
        <YouTube
          videoId={audio.id}
          opts={options}
          onReady={e => {
            setPlayer(e.target);
            setAudio({
              ...audio,
              duration: getMinutes(e.target.getDuration())
            });
          }}

        />
    );
}